import Vue from 'vue'

import { AdminConfig } from 'stylemix-vue-admin'

// Global reactive settings object.
// It's enough to declare the `_loaded` service field once,
// so that computed/watchers can subscribe to it.
const $settings = Vue.observable({
  _loaded: false,
})

Object.defineProperty(Vue.prototype, '$settings', {
  get: () => $settings,
})

function applySettings(data) {
  Object.keys(data).forEach((key) => {
    Vue.set($settings, key, data[key])
  })
  $settings._loaded = true
  document.title = `${$settings.app_name} Console` ?? 'Console'
  if ($settings.logo_url) {
    AdminConfig.setLogo($settings.logo_url)
  }
}

export default {
  created() {
    // This hook should only be executed for root component
    if (this.$root !== this) {
      return
    }

    this.loadSettings()

    this.$on('account-loaded', () => {
      this.loadSettings()
    })
  },

  methods: {
    loadSettings() {
      this.$http.get('settings').then((response) => {
        const data = response.data || {}
        applySettings(data)
      })
    },
  },
}
